import { $ } from '@/Engine/state';
import { Part } from '@/Engine/Part';

//расчет приоритетов экранов при наложении
export function setPriorityForShields(obj: Part) {
    if (!$.toolChest || !$.toolChest.shield) return;
    obj.isPriorityIndex = 0;
    $.toolChest.shield.filter((shield) => {
        //если совпадают позиции экранов
        if (
            shield.position.y == obj.position.y && 
            shield.scale.equals(obj.scale) && 
            shield !== obj
        ) {
            obj.isPriorityIndex += 1;
        }
    });
}